<mat-dialog-content>
  <label>This item is not in this picklist, try again </label>
</mat-dialog-content>

<mat-dialog-actions style="margin-top: 50px">
  <div style="display: block; width: 100%">
    <button class="mat-raised-button ok-button" (click)="save()">Ok</button>
  </div>
</mat-dialog-actions>
